<template>
    <div class="block-note-wrapper">
        <div class="block-note">
            <div class="arrow-container">
                <SmallArrow />
            </div>
            <Text size="f-8">
                <slot />
            </Text>
            <div class="arrow-container">
                <SmallArrow direction="down" />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { Text } from '@opteo/components-next'
import SmallArrow from './SmallArrow.vue'
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
@import '@/assets/css/variables.scss';

.block-note-wrapper {
    display: flex;
    justify-content: center;
}
.block-note {
    @include container;
    padding: 0.875rem 1rem;
    display: inline-flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.875rem;
    margin: auto 0;
}

.arrow-container {
    height: 20px;
    width: 20px;
    @include container;
    @include flex-center;
    border-radius: 100%;
}
</style>
